import { MenuItemType } from '../components/RHFSelectInput';

export const cupTypes: MenuItemType[] = [
  {
    id: 1,
    value: 35,
    menuItemLabel: '212ml',
  },
  {
    id: 2,
    value: 46,
    menuItemLabel: '370ml',
  },
];

export const cupPrice: MenuItemType[] = [
  {
    id: 1,
    value: 350,
    menuItemLabel: '212ml',
  },
  {
    id: 2,
    value: 550,
    menuItemLabel: '370ml',
  },
];

export const AppName = 'Džemulator';

export const TOASTIFY_AUTO_CLOSE_TIME = 3000;

export const ORDER_WIDTH = '50%';
export const ORDER_WIDTH_55 = '55%';
export const ORDER_WIDTH_60 = '60%';

export const YEARS = [
  {
    id: 1,
    value: 2025,
    menuItemLabel: '2025',
  },
  {
    id: 2,
    value: 2026,
    menuItemLabel: '2026',
  },
];

export const MONTHS = [
  {
    id: 1,
    value: 1,
    menuItemLabel: 'Januar',
  },
  {
    id: 2,
    value: 2,
    menuItemLabel: 'Februar',
  },
  {
    id: 3,
    value: 3,
    menuItemLabel: 'Mart',
  },
  {
    id: 4,
    value: 4,
    menuItemLabel: 'April',
  },
  {
    id: 5,
    value: 5,
    menuItemLabel: 'Maj',
  },
  {
    id: 6,
    value: 6,
    menuItemLabel: 'Jun',
  },
  {
    id: 7,
    value: 7,
    menuItemLabel: 'Jul',
  },
  {
    id: 8,
    value: 8,
    menuItemLabel: 'Avgust',
  },
  {
    id: 9,
    value: 9,
    menuItemLabel: 'Septembar',
  },
  {
    id: 10,
    value: 10,
    menuItemLabel: 'Oktobar',
  },
  {
    id: 11,
    value: 11,
    menuItemLabel: 'Novembar',
  },
  {
    id: 12,
    value: 12,
    menuItemLabel: 'Decembar',
  },
];
